var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('span',{staticClass:"white--text"},[_vm._v("Payroll closing date for Manager Approval")]),_c('br'),_c('span',{staticClass:"black--text headline",staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.items))])])}
var staticRenderFns = []

export { render, staticRenderFns }